import { PureConnect, React } from '../../react';
import { INote, INoteShared } from '../../types';
import { notesEditor } from './resource';
import { NoteDetailsNavigator } from './details';

import cx from './style.less';
import { notechatEditor } from '../notechat/resource';
import { QuestionDetailsNavigator } from '../question/details';

export default PureConnect(`NavigatorDetails`)(
  (state) => ({
    selectNote: state.selection.creating,
    selectTextArea: state.selection.creating, 
    creating: notesEditor.selectors.creating(state),
    updating: notesEditor.selectors.updating(state),     
    deleting: notesEditor.selectors.deleting(state),  
    updatingNoteChat: notechatEditor.selectors.updating(state),  
  }),
  (dispatch) => ({
    // read: (item: INote|INoteShared) => dispatch(notesEditor.actions.READ({ item })),
  }),
  ({ selectNote, creating, updating, updatingNoteChat, deleting, selectTextArea }) => {  
      var notVisible=(creating || updating || updatingNoteChat || selectNote || selectTextArea || deleting);
      return (
        <div className={cx('note-details', notVisible ? 'wcag-invisible' : '')}>
          <NoteDetailsNavigator />
          <QuestionDetailsNavigator />
        </div>
      );
    },
  );



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/notes/navigatorDetails.tsx